import { t } from "../locale";

export default function VideoIdentificationSuccess() {
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      {/* Local styles for a tiny entrance animation */}
      <style>{`
        @keyframes popIn { 0% { transform: scale(.85); opacity: 0 } 100% { transform: scale(1); opacity: 1 } }
        .pop-in { animation: popIn .35s ease-out both; }
      `}</style>

      <div className="container px-3 px-sm-4">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6">
            <div className="card border-0 shadow-sm rounded-4 pop-in">
              <div className="card-body p-4 p-sm-5">
                {/* Success icon */}
                <div className="d-flex justify-content-center mb-3">
                  <div className="rounded-circle bg-success-subtle d-inline-flex align-items-center justify-content-center" style={{ width: 88, height: 88, border: '3px solid var(--bs-success)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="text-success" viewBox="0 0 16 16" aria-hidden="true">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.08-.02l3.992-4.99a.75.75 0 0 0-.012-1.05z"/>
                    </svg>
                  </div>
                </div>

                <h2 className="text-center mb-2">{t('successTitle')}</h2>
                <p className="text-center text-muted mb-4">
                  {t('successThanks')}
                </p>

                {/* Status / Next steps */}
                <div className="list-group mb-4">
                  <div className="list-group-item border-0 d-flex align-items-start gap-3">
                    <span className="badge bg-success-subtle text-success fw-semibold rounded-pill">1</span>
                    <div>
                      <div className="fw-semibold">{t('step1Title')}</div>
                      <div className="text-muted small">{t('step1Desc')}</div>
                    </div>
                  </div>
                  <div className="list-group-item border-0 d-flex align-items-start gap-3">
                    <span className="badge bg-primary-subtle text-primary fw-semibold rounded-pill">2</span>
                    <div>
                      <div className="fw-semibold">{t('step2Title')}</div>
                      <div className="text-muted small">{t('step2Desc')}</div>
                    </div>
                  </div>
                  <div className="list-group-item border-0 d-flex align-items-start gap-3">
                    <span className="badge bg-warning-subtle text-dark fw-semibold rounded-pill">3</span>
                    <div>
                      <div className="fw-semibold">{t('step3Title')}</div>
                      <div className="text-muted small">{t('step3Desc')}</div>
                    </div>
                  </div>
                </div>

                {/* Info notice */}
                <div className="alert alert-info rounded-3" role="alert">
                  <div className="d-flex align-items-start gap-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-info-circle flex-shrink-0 mt-1" viewBox="0 0 16 16" aria-hidden="true">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469L6.5 10.5c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z"/>
                      <circle cx="8" cy="4.5" r="1"/>
                    </svg>
                    <div>
                      <div className="fw-semibold">{t('infoTitle')}</div>
                      <div className="text-muted small">{t('infoDesc')}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-center text-muted small mt-3 mb-0">{t('footerTagline')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
